import ZJApi from './src/api'
import UserApi from './src/user-api'
import OrgUserApi from './src/org-user-api'
import OrgApi from './src/org-api'
import UserRoleApi from './src/user-role-api'
import RoleApi from './src/role-api'
import FuncApi from './src/func-api'
import UniformConfigApi from './src/uconfig-api'
import FileApi from './src/file-api'
import ZJUploader from './src/zjuploader'
import CaptchaApi from './src/captcha-api'

import SendSmsApi from './src/sms-api'
import EarlymsgApi from './src/earlyMsg'
import OperationLogApi from './src/operation-log-api'
import ErrorLogApi from './src/error-log-api'



const cmps = {
    ZJApi,
    UserApi,
    OrgUserApi,
    OrgApi,
    UserRoleApi,
    RoleApi,
    FuncApi,
    UniformConfigApi,
    FileApi,
    ZJUploader,
    CaptchaApi,
    SendSmsApi,
    EarlymsgApi,
    OperationLogApi,
    ErrorLogApi,

}

export default cmps